var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['skeleton', _vm.variantClass, _vm.animationClass, _vm.className],style:(_vm.customStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }